<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col lg:flex-row lg:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
        สรุปรายได้
        <span class="text-sm font-black text-amber-600 bg-amber-50 dark:bg-amber-900/30 px-2.5 py-1 rounded-lg">Revenue</span>
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        รายได้ทั้งหมดแยกตามประเภทค่าธรรมเนียม (parking_type_fee) · สถิติรายเดือน + % เปรียบเทียบ
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 no-print">
      <div *ngIf="lastFetchedTime"
        class="flex flex-col items-end justify-center text-right shrink-0 w-[112px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()" [disabled]="!canSearch || isLoading()" title="รีเฟรช"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center cursor-pointer disabled:opacity-40">
        <span class="material-icons">refresh</span>
      </button>
      <button type="button" (click)="onExportExcel()"
        [disabled]="!result() || isLoading() || isExporting()"
        class="px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-emerald-600 dark:text-emerald-400 font-bold rounded-2xl shadow-sm border border-emerald-100 dark:border-emerald-900 hover:bg-emerald-50 transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40">
        <span class="material-icons text-[18px]">table_view</span>
        {{ isExporting() ? 'กำลังส่งออก...' : 'ส่งออก Excel' }}
      </button>
      <button type="button" (click)="onPrintPdf()"
        [disabled]="!result() || isLoading() || isProcessingPdf()"
        class="px-4 py-3 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
        <span class="material-icons text-[18px]">picture_as_pdf</span>
        {{ isProcessingPdf() ? 'กำลังสร้าง PDF...' : 'พิมพ์ PDF' }}
      </button>
      <button type="button" (click)="onCapturePdf()"
        [disabled]="!result() || isLoading() || isCapturing()"
        title="บันทึกหน้าจอนี้เป็น PDF (เหมือนหน้าเว็บ)"
        class="px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-amber-600 dark:text-amber-400 font-bold rounded-2xl shadow-sm border border-amber-200 dark:border-amber-900 hover:bg-amber-50 transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40">
        <span class="material-icons text-[18px]">screenshot_monitor</span>
        {{ isCapturing() ? 'กำลังแคปหน้าจอ...' : 'แคปหน้าจอเป็น PDF' }}
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden mb-6">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 space-y-4">
      <div class="flex flex-wrap items-center gap-2">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">tune</span>
          เงื่อนไข
        </h3>
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
      </div>

      <div *ngIf="!selectedSiteId"
        class="rounded-2xl border border-amber-200 dark:border-amber-800 bg-amber-50/80 dark:bg-amber-900/20 px-4 py-3 text-sm font-medium text-amber-800 dark:text-amber-300">
        กรุณาเลือกลานจาก Navbar ก่อน
      </div>

      <div class="flex flex-wrap gap-2">
        <button type="button" (click)="onPeriodModeChange('year')"
          class="px-4 py-2 rounded-xl text-xs font-bold border transition-all cursor-pointer"
          [ngClass]="periodMode === 'year'
            ? 'bg-amber-400 border-amber-400 text-slate-900'
            : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-500'">
          รายปี
        </button>
        <button type="button" (click)="onPeriodModeChange('range')"
          class="px-4 py-2 rounded-xl text-xs font-bold border transition-all cursor-pointer"
          [ngClass]="periodMode === 'range'
            ? 'bg-amber-400 border-amber-400 text-slate-900'
            : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-500'">
          ช่วงวันที่
        </button>
      </div>

      <div class="flex flex-col lg:flex-row lg:items-end gap-4">
        <div *ngIf="periodMode === 'year'" class="w-full sm:w-48">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">ปี</label>
          <select [(ngModel)]="yearValue" (ngModelChange)="onYearChange()"
            class="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 font-medium outline-none focus:ring-2 focus:ring-amber-300">
            <option *ngFor="let y of yearOptions" [value]="y">{{ y }}</option>
          </select>
        </div>

        <ng-container *ngIf="periodMode === 'range'">
          <div class="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">วันเริ่มต้น</label>
              <input type="date" [(ngModel)]="startDate" (ngModelChange)="onFilterChange()"
                class="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 font-medium outline-none focus:ring-2 focus:ring-amber-300" />
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">วันสิ้นสุด</label>
              <input type="date" [(ngModel)]="endDate" [attr.max]="maxEndDate" (ngModelChange)="onFilterChange()"
                class="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 font-medium outline-none focus:ring-2 focus:ring-amber-300" />
            </div>
          </div>
        </ng-container>

        <button type="button" (click)="onSearch()" [disabled]="!canSearch || isLoading()"
          class="h-[46px] px-6 shrink-0 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-xl shadow-sm transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
          <span class="material-icons text-[20px]">insights</span>
          {{ isLoading() ? 'กำลังโหลด...' : 'ดูสรุป' }}
        </button>
      </div>

      <p class="text-[11px] text-slate-400 font-medium">
        ช่วงที่เลือก: {{ periodLabel }} · สูงสุด 12 เดือน · นับจาก PaidDate · ยอด = Fee + VAT
      </p>
    </div>
  </div>

  <div *ngIf="!isLoading() && !hasSearched()" class="py-16 text-center text-slate-400">
    <span class="material-icons text-4xl mb-2 block opacity-40">account_balance</span>
    <p class="font-bold">เลือกลานและช่วงเวลา แล้วกดดูสรุป</p>
  </div>

  <ng-container *ngIf="result() as data">
   <div #captureArea>
    <div *ngIf="isCapturing()" class="mb-6 rounded-2xl border border-slate-200 bg-white px-6 py-4 flex flex-wrap items-end justify-between gap-4">
      <div>
        <h2 class="text-2xl font-extrabold text-slate-800 flex items-center gap-3">
          สรุปรายได้
          <span class="text-sm font-black text-amber-600 bg-amber-50 px-2.5 py-1 rounded-lg">Revenue</span>
        </h2>
        <p class="text-slate-500 mt-1 font-medium">รายได้ทั้งหมดแยกตามประเภทค่าธรรมเนียม · ยอด = Fee + VAT · นับจากวันที่ชำระ</p>
      </div>
      <div class="text-right text-xs text-slate-500 font-medium space-y-0.5">
        <p class="text-sm font-bold text-slate-700">{{ data.siteName || siteState.selectedSite()?.name || '—' }}</p>
        <p *ngIf="data.siteAddress">{{ data.siteAddress }}</p>
        <p *ngIf="data.siteTaxId">เลขผู้เสียภาษี {{ data.siteTaxId }}</p>
        <p>{{ periodLabel }} ({{ formatDisplayDate(startDate) }} – {{ formatDisplayDate(endDate) }})</p>
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <div *ngFor="let stat of data.kpiCards; let i = index"
        class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-2xl p-5 shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden"
        [ngStyle]="{'animation-delay': (i * 0.04) + 's'}">
        <div class="flex justify-between items-start mb-3">
          <div class="w-10 h-10 rounded-xl flex items-center justify-center bg-slate-50 dark:bg-slate-900/60" [ngClass]="stat.color">
            <span class="material-icons text-xl">{{ stat.icon }}</span>
          </div>
        </div>
        <h4 class="text-slate-400 text-[10px] font-bold uppercase tracking-wider mb-1">{{ stat.title }}</h4>
        <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tabular-nums break-all">{{ stat.value }}</div>
        <p *ngIf="stat.hint" class="text-[11px] text-slate-400 mt-1 font-medium truncate">{{ stat.hint }}</p>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3 mb-6">
      <div class="peak-chip" [ngClass]="trendToneClass(data.trendInsight.direction)">
        <p class="peak-chip__label">ทิศทางแนวโน้มรายได้</p>
        <p class="peak-chip__value peak-chip__value--trend">
          <span class="material-icons trend-icon">{{ trendIcon(data.trendInsight.direction) }}</span>
          {{ data.trendInsight.label }}
        </p>
        <p class="peak-chip__meta" *ngIf="data.trendInsight.periodChangePercent !== null">
          {{ data.trendInsight.firstLabel }} → {{ data.trendInsight.lastLabel }}
          · {{ formatMomPercent(data.trendInsight.periodChangePercent) }}
        </p>
        <p class="peak-chip__meta tabular-nums" *ngIf="data.trendInsight.periodChangePercent !== null">
          {{ formatMoney(data.trendInsight.firstAmount) }} → {{ formatMoney(data.trendInsight.lastAmount) }}
        </p>
      </div>
      <div class="peak-chip peak-chip--emerald">
        <p class="peak-chip__label">เดือนรายได้สูงสุด</p>
        <p class="peak-chip__value">
          {{ data.summary.peakMonthLabel || '—' }}
          <span>{{ formatMoney(data.summary.peakMonthAmount) }}</span>
        </p>
      </div>
      <div class="peak-chip peak-chip--slate">
        <p class="peak-chip__label">เดือนรายได้ต่ำสุด</p>
        <p class="peak-chip__value">
          {{ data.summary.lowestMonthLabel || '—' }}
          <span>{{ formatMoney(data.summary.lowestMonthAmount) }}</span>
        </p>
      </div>
      <div class="peak-chip peak-chip--amber">
        <p class="peak-chip__label">MoM เดือนล่าสุด (จบแล้ว)</p>
        <p class="peak-chip__value" [ngClass]="trendToneClass(directionFromPercent(data.summary.momChangePercent))">
          {{ formatMomPercent(data.summary.momChangePercent) }}
        </p>
        <p class="peak-chip__meta" *ngIf="hasIncompleteMonth(data.monthlySeries)">ไม่นับเดือนปัจจุบันที่ยังไม่จบ</p>
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6" *ngIf="data.monthlySeries.length >= 2">
      <div class="trend-stat">
        <span class="material-icons text-emerald-500 text-[18px]">arrow_upward</span>
        <div>
          <p class="trend-stat__label">เดือนที่ขึ้น</p>
          <p class="trend-stat__value">{{ data.trendInsight.risingMonths }}</p>
        </div>
      </div>
      <div class="trend-stat">
        <span class="material-icons text-rose-500 text-[18px]">arrow_downward</span>
        <div>
          <p class="trend-stat__label">เดือนที่ลง</p>
          <p class="trend-stat__value">{{ data.trendInsight.fallingMonths }}</p>
        </div>
      </div>
      <div class="trend-stat">
        <span class="material-icons text-slate-400 text-[18px]">horizontal_rule</span>
        <div>
          <p class="trend-stat__label">MoM เฉลี่ย</p>
          <p class="trend-stat__value" [ngClass]="trendToneClass(directionFromPercent(data.trendInsight.avgMomPercent))">
            {{ formatMomPercent(data.trendInsight.avgMomPercent) }}
          </p>
        </div>
      </div>
    </div>

    <!-- Main: stacked monthly by type_fee + donut (one row) -->
    <div class="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
      <div class="xl:col-span-8 chart-card">
        <div class="chart-card__head">
          <div>
            <h3 class="chart-card__title">รายได้รายเดือนแยกประเภท</h3>
            <p class="chart-card__sub">แท่งซ้อนตาม parking_type_fee · เส้น = แนวโน้มรายได้รวม · แกนซ้าย = ตัวเลขยอด</p>
          </div>
        </div>
        <div class="chart-legend" *ngIf="data.typeFeeBreakdown.length > 0">
          <span *ngFor="let v of data.typeFeeBreakdown" class="chart-legend__item">
            <i class="dot" [style.background]="v.color" [style.box-shadow]="'0 0 0 3px ' + v.color + '26'"></i>
            {{ v.typeFeeName }}
          </span>
          <span class="chart-legend__item"><i class="dot dot--line"></i>แนวโน้มรวม</span>
        </div>

        <div *ngIf="data.monthlySeries.length === 0" class="py-12 text-center text-slate-400 font-medium">ไม่มีข้อมูลในช่วงนี้</div>

        <div *ngIf="data.monthlySeries.length > 0" class="bar-chart" (mouseleave)="hoveredMonth.set(null)">
          <div class="bar-chart__y-axis" aria-hidden="true">
            <span *ngFor="let t of chartAxisTicksMoney(data.chartMaxAmount)">{{ t.label }}</span>
          </div>
          <div class="bar-chart__plot">
            <svg *ngIf="data.trendInsight.linePoints"
              class="trend-line-svg"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              aria-hidden="true">
              <polyline
                [attr.points]="data.trendInsight.linePoints"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                vector-effect="non-scaling-stroke" />
              <circle *ngFor="let d of data.trendInsight.lineDots"
                [attr.cx]="d.x"
                [attr.cy]="d.y"
                r="1.6"
                fill="currentColor" />
            </svg>
            <div class="bar-chart__cols">
              <div *ngFor="let m of data.monthlySeries; let i = index"
                class="bar-col"
                (mouseenter)="hoveredMonth.set(i)">
                <div class="bar-col__stack bar-col__stack--vt" [style.height.%]="m.amountPct">
                  <div *ngFor="let seg of m.segments; let si = index"
                    class="bar-segment"
                    [style.flex-grow]="seg.amount || 0.0001"
                    [style.background]="seg.color"
                    [class.bar-segment--top]="si === m.segments.length - 1"
                    [class.bar-segment--peak]="m.isPeak && si === m.segments.length - 1"></div>
                </div>
                <span class="bar-col__mom" *ngIf="m.isIncompleteMonth" [ngClass]="trendToneClass('pending')">
                  ยังไม่จบ
                </span>
                <span class="bar-col__mom" *ngIf="!m.isIncompleteMonth && m.momChangePercent !== null"
                  [ngClass]="trendToneClass(m.trend)">
                  {{ formatMomPercent(m.momChangePercent) }}
                </span>
                <span class="bar-col__label" [class.bar-col__label--dense]="data.monthlySeries.length > 8">{{ m.label }}</span>
              </div>
            </div>
            <div *ngIf="hoveredMonth() !== null" class="chart-tooltip"
              [style.left.%]="((hoveredMonth()! + 0.5) / data.monthlySeries.length) * 100">
              <p class="chart-tooltip__date">{{ data.monthlySeries[hoveredMonth()!].label }}</p>
              <p><span class="text-emerald-400">รวม</span> {{ formatMoney(data.monthlySeries[hoveredMonth()!].amount) }}</p>
              <p><span class="text-sky-400">ใบเสร็จ</span> {{ data.monthlySeries[hoveredMonth()!].receiptCount | number }}</p>
              <p *ngFor="let seg of data.monthlySeries[hoveredMonth()!].segments">
                <span [style.color]="seg.color">{{ seg.typeFeeName }}</span>
                {{ formatMoney(seg.amount) }} ({{ seg.pct }}%)
              </p>
              <p *ngIf="data.monthlySeries[hoveredMonth()!].isIncompleteMonth" class="chart-tooltip__mom">
                เดือนปัจจุบันยังไม่จบ — ยังไม่สรุปแนวโน้ม
              </p>
              <p *ngIf="!data.monthlySeries[hoveredMonth()!].isIncompleteMonth && data.monthlySeries[hoveredMonth()!].momDelta !== null" class="chart-tooltip__mom">
                เทียบเดือนก่อน
                {{ formatSignedMoney(data.monthlySeries[hoveredMonth()!].momDelta) }}
                ({{ formatMomPercent(data.monthlySeries[hoveredMonth()!].momChangePercent) }})
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="xl:col-span-4 chart-card">
        <div class="chart-card__head">
          <div>
            <h3 class="chart-card__title">สัดส่วนประเภท</h3>
            <p class="chart-card__sub">จากยอดรายได้ในช่วงที่เลือก</p>
          </div>
        </div>
        <div class="donut-wrap">
          <div class="donut" [style.background]="data.typeFeeDonutGradient">
            <div class="donut__hole">
              <span class="donut__value" style="font-size: 0.85rem; line-height: 1.15;">{{ formatMoney(data.summary.totalAmount) }}</span>
              <span class="donut__label">บาท</span>
            </div>
          </div>
          <ul class="donut-legend">
            <li *ngFor="let v of data.typeFeeBreakdown" class="justify-between gap-2">
              <span class="inline-flex items-center gap-2 min-w-0">
                <i class="dot shrink-0" [style.background]="v.color"></i>
                <span class="truncate">{{ v.typeFeeName }}</span>
              </span>
              <span class="tabular-nums shrink-0 font-bold">{{ v.percent }}% · {{ formatMoney(v.amount) }}</span>
            </li>
            <li *ngIf="data.typeFeeBreakdown.length === 0" class="text-slate-400 italic">ไม่มีรายได้</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="chart-card mb-6" *ngIf="monthCompareRows(data.monthlySeries).length > 0">
      <div class="chart-card__head">
        <div>
          <h3 class="chart-card__title">สถิติรายเดือน (MoM)</h3>
          <p class="chart-card__sub">รายได้เทียบเดือนก่อน · แยกประเภทค่าธรรมเนียม</p>
        </div>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full text-left border-collapse min-w-[800px] text-xs">
          <thead>
            <tr class="text-[10px] font-bold text-slate-400 uppercase tracking-wider text-center">
              <th class="p-2 border border-slate-100 dark:border-slate-700 text-left">เดือน</th>
              <th class="p-2 border border-slate-100 dark:border-slate-700">รายได้</th>
              <th class="p-2 border border-slate-100 dark:border-slate-700">เดือนก่อน</th>
              <th class="p-2 border border-slate-100 dark:border-slate-700">ผลต่าง</th>
              <th class="p-2 border border-slate-100 dark:border-slate-700">% เปลี่ยน</th>
              <th class="p-2 border border-slate-100 dark:border-slate-700 text-left">แยกประเภท</th>
              <th class="p-2 border border-slate-100 dark:border-slate-700">ทิศทาง</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let m of monthCompareRows(data.monthlySeries)"
              class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 tabular-nums">
              <td class="p-2 border border-slate-50 dark:border-slate-700 font-bold text-slate-700 dark:text-slate-200">
                {{ m.label }}
                <span *ngIf="m.isIncompleteMonth" class="ml-1 text-[9px] font-bold text-amber-600">ยังไม่จบ</span>
              </td>
              <td class="p-2 border border-slate-50 dark:border-slate-700 text-center text-emerald-600 dark:text-emerald-400 font-bold">
                {{ formatMoney(m.amount) }}
              </td>
              <td class="p-2 border border-slate-50 dark:border-slate-700 text-center text-slate-400">
                {{ formatMoney(m.prevAmount) }}
              </td>
              <td class="p-2 border border-slate-50 dark:border-slate-700 text-center font-bold"
                [ngClass]="trendToneClass(m.trend)">
                {{ m.isIncompleteMonth || m.momDelta === null ? '—' : formatSignedMoney(m.momDelta) }}
              </td>
              <td class="p-2 border border-slate-50 dark:border-slate-700 text-center font-bold"
                [ngClass]="trendToneClass(m.trend)">
                {{ m.isIncompleteMonth ? 'ยังไม่จบ' : (m.momChangePercent === null ? '—' : formatMomPercent(m.momChangePercent)) }}
              </td>
              <td class="p-2 border border-slate-50 dark:border-slate-700">
                <div class="flex flex-wrap gap-1.5">
                  <span *ngFor="let seg of m.segments"
                    class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-slate-50 dark:bg-slate-900/60 text-[10px] font-bold">
                    <i class="dot" [style.background]="seg.color"></i>
                    {{ seg.typeFeeName }} {{ formatMoney(seg.amount) }}
                  </span>
                  <span *ngIf="m.segments.length === 0" class="text-slate-400">—</span>
                </div>
              </td>
              <td class="p-2 border border-slate-50 dark:border-slate-700 text-center">
                <span class="material-icons text-[18px]" [ngClass]="trendToneClass(m.trend)">
                  {{ m.momDelta === null && !m.isIncompleteMonth ? 'remove' : trendIcon(m.trend) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="grid grid-cols-1 xl:grid-cols-12 gap-6">
      <div class="xl:col-span-7 chart-card">
        <div class="chart-card__head">
          <div>
            <h3 class="chart-card__title">แนวโน้มรายได้แต่ละประเภท</h3>
            <p class="chart-card__sub">เส้นรายเดือนเปรียบเทียบ parking_type_fee · แกนซ้าย = ตัวเลขยอด</p>
          </div>
        </div>
        <div class="chart-legend" *ngIf="data.typeFeeMonthlySeries.length > 0">
          <span *ngFor="let s of data.typeFeeMonthlySeries" class="chart-legend__item">
            <i class="dot" [style.background]="s.color" [style.box-shadow]="'0 0 0 3px ' + s.color + '26'"></i>
            {{ s.typeFeeName }} ({{ formatMoney(s.totalAmount) }})
          </span>
        </div>
        <div *ngIf="data.typeFeeMonthlySeries.length === 0" class="py-12 text-center text-slate-400 font-medium">
          ไม่มีรายได้แยกประเภทในช่วงนี้
        </div>
        <div *ngIf="data.typeFeeMonthlySeries.length > 0" class="bar-chart vt-line-chart">
          <div class="bar-chart__y-axis" aria-hidden="true">
            <span *ngFor="let t of chartAxisTicksMoney(data.chartMaxAmount)">{{ t.label }}</span>
          </div>
          <div class="bar-chart__plot">
            <svg class="vt-multi-line-svg" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
              <polyline *ngFor="let s of data.typeFeeMonthlySeries"
                [attr.points]="s.linePoints"
                fill="none"
                [attr.stroke]="s.color"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                vector-effect="non-scaling-stroke" />
            </svg>
            <div class="bar-chart__cols vt-line-cols">
              <div *ngFor="let m of data.monthlySeries" class="bar-col vt-line-col">
                <div class="bar-col__stack vt-line-spacer"></div>
                <span class="bar-col__label" [class.bar-col__label--dense]="data.monthlySeries.length > 8">{{ m.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="xl:col-span-5 chart-card">
        <div class="chart-card__head">
          <div>
            <h3 class="chart-card__title">ยอดแยกประเภท</h3>
            <p class="chart-card__sub">ตัวเลขรายได้ + จำนวนใบเสร็จ</p>
          </div>
        </div>
        <div *ngIf="data.typeFeeBreakdown.length === 0" class="py-8 text-center text-slate-400 font-medium">ไม่มีรายได้ในช่วงนี้</div>
        <div *ngFor="let v of data.typeFeeBreakdown" class="pkg-row">
          <div class="pkg-row__meta">
            <span class="pkg-row__name flex items-center gap-2 min-w-0">
              <i class="dot shrink-0" [style.background]="v.color"></i>
              <span class="truncate">{{ v.typeFeeName }}</span>
            </span>
            <span class="pkg-row__count tabular-nums text-emerald-600 dark:text-emerald-400 text-right">
              {{ formatMoney(v.amount) }}
              <span class="block text-[10px] text-slate-400 font-semibold">{{ v.receiptCount | number }} ใบ · {{ v.percent }}%</span>
            </span>
          </div>
          <div class="pkg-row__track">
            <div class="pkg-row__fill" [style.width.%]="v.barPct" [style.background]="v.color"></div>
          </div>
        </div>
      </div>
    </div>
   </div>
  </ng-container>
</div>

<app-modal-invoice-pdf-viewer
  *ngIf="showPdfModal()"
  [pdfSrc]="pdfSrc"
  [modalTitle]="'รายงานสรุปรายได้ (PDF)'"
  [downloadFileName]="pdfDownloadName"
  (close)="closePdfModal()">
</app-modal-invoice-pdf-viewer>

<app-pss-loading *ngIf="isLoading() || isProcessingPdf() || isCapturing()"></app-pss-loading>
